import React from 'react';
import styled from 'styled-components';
import Icon from '../images/whatsapp-link.svg';

const ButtonWhatsapp = styled.a`
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .7s ease-in-out;
    & img{
        width: 100%;
        display: block;
    }
    &:hover{
        width: 80px;
        height: 80px;
    }
    @media (max-width: 768px) {
        width: 50px;
        height: 50px;
        &:hover{
            width: 70px;
            height: 70px;
        }
    }
`;

const Whatsapp = () => {
    return (
        <ButtonWhatsapp
            href="https://wa.link/6fka4y"
            target="_blank"
        >
            <img src={Icon} alt="" />
        </ButtonWhatsapp>
    );
}

export default Whatsapp;